export enum AirAmbulanceSubscriptionOptions {
  AutoRenewal = 'autoRenewal',
}
